import { useToast } from './useToast';
import { useGroupStore } from '@/stores/group-store';

export const useRelocated = () => {
  const { showToast } = useToast();

  const handleGetRelocatedGroup = async () => {
    if (localStorage.getItem('user-organization')) {
      return JSON.parse(localStorage.getItem('user-organization') as string);
    } else {
      const { getRelocatedGroup } = useGroupStore();

      try {
        const response = await getRelocatedGroup();
        if (response) {
          localStorage.setItem('user-organization', JSON.stringify(response));
          return response;
        }
      } catch (error) {
        await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
      }
    }
  };

  return { handleGetRelocatedGroup };
};
